export const generateRandomString = (length) => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};



export const filterByArtist = (tracks) => {
  // Créer un objet Set pour stocker les noms d'artistes déjà rencontrés
  const nomsArtistes = new Set();
  
  // Filtrer le tableau de musiques
  const musiquesFiltrees = tracks.filter((track) => {
    // Vérifier si le nom de l'artiste a déjà été rencontré
    if (nomsArtistes.has(track.artist)) {
      // Si le nom d'artiste est déjà présent dans l'ensemble, retourner false pour filtrer la musique
      return false;
    }
    // Ajouter le nom de l'artiste à l'ensemble des noms d'artistes
    nomsArtistes.add(track.artist);
    // Retourner true pour inclure la musique dans le tableau filtré
    return true;
  });
  
  // Retourner le tableau de musiques filtrées
  return musiquesFiltrees;
}


export const formatterVers = (texte) => {
  // Supprimer les espaces en début et fin de texte
  texte = texte.trim();

  // Diviser le texte en lignes
  var lignes = texte.split('\n');

  // Supprimer les lignes vides
  lignes = lignes.filter(function(ligne) {
    return ligne.trim() !== '';
  });

  // Ajouter un retour à la ligne après chaque ligne non vide
  var vers = lignes.join('\n\n');

  return vers;
}


export const getRandomUri = (ids, max) => {
  const pre = Math.floor(Math.random() * max)
   
  if (ids.length > max) {
    return -1
  }
  else if (ids.includes(pre) ) {
    return getRandomUri(ids, max)
  }
  else {
    return pre
  }
}